import apiClient from './api-client';
import { saveToken, saveClienteId } from './util.service';

/**
 * Realiza o login de um cliente
 * @param {Object} credentials - Credenciais de login
 * @param {string} credentials.codigo - Código do cliente
 * @param {string} credentials.senha - Senha do cliente
 * @returns {Promise<Object>} Dados do login
 */
export const loginCliente = async (credentials) => {
  try {
    const response = await apiClient.post('/clientes/login', credentials);

    // Se o login retornar um token, armazena no localStorage
    if (response.data && response.data.token) {
      saveToken(response.data.token);
    }

    // Se o login retornar o ID do cliente, armazena no localStorage
    if (response.data && response.data.data && response.data.data.id) {
      saveClienteId(response.data.data.id);
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};
